// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Applicative_Extra from "../Control.Applicative.Extra/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Debug from "../Debug/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_AffE from "../Effect.AffE/index.js";
import * as Restaumatic_Prelude from "../Restaumatic.Prelude/index.js";
import * as Restaumatic_Prelude_SpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP from "../Specular.FRP/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var wempty = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
export {
    wempty
};
export {
    for2
} from "../Control.Applicative.Extra/index.js";
export {
    ask
} from "../Control.Monad.Reader.Class/index.js";
export {
    cmap,
    cmapFlipped,
    cvoid,
    cvoidLeft,
    cvoidRight
} from "../Data.Functor.Contravariant.Compat/index.js";
export {
    debugger,
    spy,
    spyWith,
    trace,
    traceM
} from "../Debug/index.js";
export {
    liftAff
} from "../Effect.Aff.Class/index.js";
export {
    Left,
    Right,
    Just,
    Nothing,
    EQ,
    GT,
    LT,
    T2,
    Tuple,
    abs,
    absurd,
    add,
    all,
    alt,
    and,
    any,
    ap,
    append,
    apply,
    applyUnwrap,
    applyUnwrapFlipped,
    applyUnwrapUnwrapped,
    applyUnwrapUnwrappedFlipped,
    applyUnwrapped,
    applyUnwrappedFlipped,
    between,
    bind,
    bottom,
    choose,
    clamp,
    compare,
    comparing,
    compose,
    compose2,
    composeFlippedUnwrapArg,
    composeFlippedUnwrapArgFun,
    composeFlippedUnwrapArgFunRes,
    composeFlippedUnwrapFun,
    composeFlippedUnwrapFunRes,
    composeFlippedUnwrapRes,
    composeUnwrapArg,
    composeUnwrapArgFun,
    composeUnwrapArgFunRes,
    composeUnwrapFun,
    composeUnwrapFunRes,
    composeUnwrapRes,
    conj,
    const,
    curry,
    degree,
    discard,
    disj,
    div,
    either,
    elem,
    empty,
    eq,
    find,
    findMap,
    flap,
    flip,
    fold,
    foldM,
    foldMap,
    foldMapDefaultL,
    foldMapDefaultR,
    foldl,
    foldlDefault,
    foldr,
    foldrDefault,
    for,
    for_,
    fromJust,
    fromLeft,
    fromMaybe,
    fromMaybe$prime,
    fromRight,
    fromTuple,
    fst,
    gcd,
    genericBottom,
    genericCardinality,
    genericCompare,
    genericEq,
    genericFromEnum,
    genericPred,
    genericShow,
    genericSucc,
    genericToEnum,
    genericTop,
    getField,
    guard,
    hush,
    identity,
    ifM,
    indexl,
    indexr,
    intercalate,
    isJust,
    isLeft,
    isNothing,
    isRight,
    join,
    lcm,
    length,
    lift2,
    liftA1,
    liftEffect,
    liftM1,
    lookup,
    map,
    mapAccumL,
    mapAccumR,
    mapUnwrap,
    mapUnwrapFlipped,
    max,
    maximum,
    maximumBy,
    maybe,
    maybe$prime,
    mempty,
    min,
    minimum,
    minimumBy,
    mod,
    mul,
    munless,
    mwhen,
    mwith,
    negate,
    not,
    notElem,
    notEq,
    note,
    note$prime,
    null,
    one,
    oneOf,
    oneOfMap,
    optional,
    or,
    otherwise,
    product,
    proj1,
    proj2,
    pure,
    recip,
    scale,
    scanl,
    scanr,
    sequence,
    sequenceDefault,
    sequence_,
    show,
    snd,
    sub,
    sum,
    surround,
    surroundMap,
    swap,
    toTuple,
    top,
    traverse,
    traverseDefault,
    traverse_,
    uncurry,
    unit,
    unless,
    unlessM,
    unwrap,
    void,
    when,
    whenM,
    wrap,
    zero
} from "../Restaumatic.Prelude/index.js";
export {
    gateCallback,
    gateEvent,
    onClickPreventDefault_,
    onSubmitPreventDefault_,
    whenNothingD
} from "../Restaumatic.Prelude.SpecularExtra/index.js";
export {
    attachEvent,
    contramapCallbackDyn,
    contramapCallbackDyn_,
    mkCallback,
    newCallback,
    triggerCallback
} from "../Specular.Callback/index.js";
export {
    Prop,
    attr,
    attrD,
    attrUnless,
    attrUnlessD,
    attrWhen,
    attrWhenD,
    attrs,
    attrsD,
    attrsUnless,
    attrsUnlessD,
    attrsWhen,
    attrsWhenD,
    bindChecked,
    bindValueOnChange,
    bindValueOnInput,
    checkedD,
    classUnless,
    classUnlessD,
    classWhen,
    classWhenD,
    class_,
    classes,
    classesD,
    dynText,
    el,
    el$prime,
    el_,
    on,
    onClick,
    onClick_,
    preventDefault,
    rawHtml,
    stopPropagation,
    text,
    valueD
} from "../Specular.Dom.Element/index.js";
export {
    emptyWidget,
    liftWidget
} from "../Specular.Dom.Widget/index.js";
export {
    switch
} from "../Specular.Extra.Switch/index.js";
export {
    changed,
    dynamic,
    dynamic_,
    filterEvent,
    filterJustEvent,
    filterMapEvent,
    foldDyn,
    holdDyn,
    holdUniqDynBy,
    leftmost,
    never,
    newEvent,
    readDynamic,
    subscribeDyn,
    subscribeDyn_,
    subscribeEvent_,
    tagDyn,
    uniqDyn,
    uniqDynBy,
    whenJustD,
    withDynamic_
} from "../Specular.FRP/index.js";
export {
    Loaded,
    Loading,
    NotRequested,
    asyncRequest,
    asyncRequestMaybe,
    fromLoaded,
    performEvent
} from "../Specular.FRP.Async/index.js";
export {
    unlessD,
    whenD,
    withRefUniqDynamic_,
    withUniqDynamic_
} from "../Specular.FRP.Extra/index.js";
export {
    Host,
    liftHost,
    runHost
} from "../Specular.FRP.Host/index.js";
export {
    newRef,
    refUpdate,
    refUpdateConst,
    refValue,
    updateRef
} from "../Specular.Ref/index.js";
export {
    Proxy
} from "../Type.Proxy/index.js";
